import * as React from "react";

import { Content } from "./StickyTableHeaderCaption.styles";

export interface StickyTableHeaderCaptionProps {
    children: React.ReactNode;
    type: "captionHeader";
    align?: "right";
}

export function StickyTableHeaderCaption(props: StickyTableHeaderCaptionProps): JSX.Element {
    return (
        <div>
            <Content alignRight={props.align === "right"}>{props.children}</Content>
        </div>
    );
}
